import { memo } from "react";

import { useMapContextSafe } from "components/map/hooks/useMapContext";

import "./HorizontalLoading.scss";

interface HorizontalLoadingProps {
  isLoading?: boolean;
}

function HorizontalLoading({ isLoading: isLoadingProp }: HorizontalLoadingProps) {
  const mapContext = useMapContextSafe();
  const isLoading = isLoadingProp ?? mapContext?.isLoading ?? false;

  return (
    <div style={{ position: "relative" }}>
      <div className={`slider ${isLoading ? "" : "hidden"}`}>
        <div className="line"></div>
        <div className="subline inc"></div>
        <div className="subline dec"></div>
      </div>
    </div>
  );
}

export default memo(HorizontalLoading);
